<xemex-authorization-container>
  <div class="flex flex-col items-center gap-4 text-center">
    <div
      class="flex items-center justify-center w-16 h-16 rounded-full bg-status-success text-primary"
    >
      <mat-icon>mark_email_read</mat-icon>
    </div>

    <h1 class="text-2xl font-bold">{{ 'resetPassword.success.title' | translate }}</h1>
    <p class="text-sm text-neutral">{{ 'resetPassword.success.desc' | translate }}</p>

    <xemex-filled-button class="w-full" [fullWidth]="true" (click)="backToLogin()">
      {{ 'general.btnBackToLogin' | translate }}
    </xemex-filled-button>
  </div>
</xemex-authorization-container>
